import {
  SettingsConfig,
  IntegrationsConfig,
  PaymentsConfig,
  IPaymentGateways,
  GatewayStateConfigType,
  UserProfileState,
  UserProfileErrorState
} from 'src/lib/types/settings'
import {
  ShoppingBag,
  Zap,
  CreditCard,
  Radio,
  Link,
  Users,
  Umbrella,
  Terminal,
  Thermometer,
  FileText,
  User,
  Briefcase
} from 'react-feather'
import { DatacenterOption, IdentityOptionType } from 'src/lib/types/integrations'
import MembersLookup from 'src/components/settings/members-roles/MembersLookup'
import { ChannelCreationFormErrorState } from '../lib/types/settings'
import { permissionType } from 'src/lib/utils/constants'

export const integrationsConfigType = {
  ADDITIONAL_SCRIPTS: 'ADDITIONAL_SCRIPTS',
  GOOGLE_AD: 'google_ad',
  GOOGLE_ANALYTICS: 'ga',
  GOOGLE_TAG_MANAGER: 'gtm',
  FACEBOOK: 'facebook',
  WEBENGAGE: 'webengage',
  CONTLO: 'contlo',
  MOENGAGE: 'moengage',
  CLEVERTAP: 'clevertap',
  KLAVIYO: 'klaviyo',
  OMNISEND: 'omnisend',
  AISENSY: 'aisensy',
  YCLOUD: 'ycloud',
  LIMECHAT: 'limechat',
  WEBHOOKS: 'webhooks',
  SHIP_ROCKET: 'SHIP_ROCKET',
  CLICKPOST: 'CLICKPOST',
  ITHINK_LOGISTICS: 'ITHINK_LOGISTICS',
  DELHIVERY: 'DELHIVERY',
  SHIP_DELIGHT: 'SHIP_DELIGHT',
  POP_COINS: 'POP_COINS',
  PRO_SHIP: 'PRO_SHIP',
  EASY_ECOM_CLICK_POST: 'EASY_ECOM_CLICK_POST',
  DRIVEMETADATA: 'drivemetadata',
  YOTPO: 'YOTPO',
  RETENZY: 'RETENZY',
  NECTOR: 'NECTOR',
  YOUR_TOKEN: 'YOUR_TOKEN',
  FLITS: 'FLITS',
  CASA: 'CASA',
  REWARD_RALLY: 'REWARD_RALLY',
  E_REWARDS: 'E_REWARDS'
}

export const integrationsConfig: IntegrationsConfig[] = [
  {
    type: integrationsConfigType.GOOGLE_AD,
    imgPath: '/images/integrations/google-ad.png',
    label: 'Google Ads',
    category: 'analytics'
  },
  {
    type: integrationsConfigType.GOOGLE_ANALYTICS,
    imgPath: '/images/integrations/google-analytics.png',
    label: 'Google Analytics',
    category: 'analytics'
  },
  {
    type: integrationsConfigType.GOOGLE_TAG_MANAGER,
    imgPath: '/images/integrations/google-tag-manager.png',
    label: 'Google Tag Manager',
    category: 'analytics'
  },
  {
    type: integrationsConfigType.FACEBOOK,
    imgPath: '/images/integrations/facebook.png',
    label: 'Facebook Pixel and Conversions',
    category: 'analytics'
  },
  {
    type: integrationsConfigType.WEBENGAGE,
    imgPath: '/images/integrations/webengage.png',
    label: 'WebEngage',
    category: 'marketing'
  },
  {
    type: integrationsConfigType.CONTLO,
    imgPath: '/images/integrations/contlo.png',
    label: 'Contlo',
    category: 'marketing'
  },
  {
    type: integrationsConfigType.MOENGAGE,
    imgPath: '/images/integrations/moengage.png',
    label: 'Moengage',
    category: 'marketing'
  },
  {
    type: integrationsConfigType.CLEVERTAP,
    imgPath: '/images/integrations/clevertap.png',
    label: 'Clevertap',
    category: 'marketing'
  },
  {
    type: integrationsConfigType.KLAVIYO,
    imgPath: 'https://image.shopflo.com/klaviyo.png',
    label: 'Klaviyo',
    category: 'marketing'
  },
  {
    type: integrationsConfigType.OMNISEND,
    imgPath: 'https://image.shopflo.com/omnisend.svg',
    label: 'Omnisend',
    category: 'marketing'
  },
  {
    type: integrationsConfigType.AISENSY,
    imgPath: 'https://image.shopflo.com/aisensy.png',
    label: 'AiSensy',
    category: 'marketing'
  },
  {
    type: integrationsConfigType.YCLOUD,
    imgPath: 'https://image.shopflo.com/ycloud.png',
    label: 'YCloud',
    category: 'marketing'
  },
  {
    type: integrationsConfigType.LIMECHAT,
    imgPath: '/images/integrations/limechat.png',
    label: 'Limechat',
    category: 'marketing'
  },
  {
    type: integrationsConfigType.LIMECHAT,
    imgPath: '/images/integrations/limechat.png',
    label: 'Limechat',
    category: 'marketing'
  },
  {
    type: integrationsConfigType.WEBHOOKS,
    imgPath: '/images/integrations/shopping-cart.png',
    label: 'Abandoned Cart Webhooks',
    category: 'marketing',
    permissionId: permissionType.ACR_EVENT_WEBHOOK
  },
  {
    type: integrationsConfigType.SHIP_ROCKET,
    imgPath: '/images/integrations/shiprocket.png',
    label: 'Shiprocket',
    category: 'shipping'
  },
  {
    type: integrationsConfigType.CLICKPOST,
    imgPath: '/images/integrations/clickpost.png',
    label: 'ClickPost',
    category: 'shipping'
  },
  {
    type: integrationsConfigType.ITHINK_LOGISTICS,
    imgPath: '/images/integrations/ithinklogistics.png',
    label: 'iThink Logistics',
    category: 'shipping'
  },
  {
    type: integrationsConfigType.DELHIVERY,
    imgPath: '/images/integrations/Delhivery.png',
    label: 'Delhivery',
    category: 'shipping'
  },
  {
    type: integrationsConfigType.SHIP_DELIGHT,
    imgPath: '/images/integrations/Instalogix.png',
    label: 'Instalogix',
    category: 'shipping'
  },
  {
    type: integrationsConfigType.POP_COINS,
    imgPath: '/images/integrations/popcoins.png',
    label: 'POPcoins',
    category: 'rewards'
  },
  {
    type: integrationsConfigType.YOTPO,
    imgPath: 'https://image.shopflo.com/yotpo.png',
    label: 'Yotpo',
    category: 'rewards'
  },
  {
    type: integrationsConfigType.RETENZY,
    imgPath: 'https://image.shopflo.com/retenzy.png',
    label: 'Retenzy',
    category: 'rewards'
  },
  {
    type: integrationsConfigType.NECTOR,
    imgPath: 'https://image.shopflo.com/nector.png',
    label: 'Nector',
    category: 'rewards'
  },
  {
    type: integrationsConfigType.YOUR_TOKEN,
    imgPath: 'https://image.shopflo.com/yourtoken.png',
    label: 'YourToken',
    category: 'rewards'
  },
  {
    type: integrationsConfigType.FLITS,
    imgPath: 'https://image.shopflo.com/flits.png',
    label: 'Flits',
    category: 'rewards'
  },
  {
    type: integrationsConfigType.CASA,
    imgPath: 'https://image.shopflo.com/casa.png',
    label: 'CASA',
    category: 'rewards'
  },
  {
    type: integrationsConfigType.REWARD_RALLY,
    imgPath: 'https://image.shopflo.com/reward-rally.png',
    label: 'Reward Rally',
    category: 'rewards'
  },
  {
    type: integrationsConfigType.E_REWARDS,
    imgPath: 'https://image.shopflo.com/erewards.png',
    label: 'eRewards',
    category: 'rewards'
  },
  {
    type: integrationsConfigType.DRIVEMETADATA,
    imgPath: '/images/integrations/drivemetadata.png',
    label: 'DriveMetadata',
    category: 'analytics'
  },
  {
    type: integrationsConfigType.ADDITIONAL_SCRIPTS,
    label: 'Additional Scripts',
    category: 'additional_scripts',
    imgPath: '/images/additional-scripts.svg'
  },
  {
    type: integrationsConfigType.PRO_SHIP,
    imgPath: '/images/integrations/proship.svg',
    label: 'Proship',
    category: 'shipping'
  },
  {
    type: integrationsConfigType.EASY_ECOM_CLICK_POST,
    imgPath: 'https://image.shopflo.com/truck-icon.svg',
    label: 'Multi-warehouse EDD (with easyecom + clickpost)',
    category: 'shipping'
  }
]

export const moengageDataCenterOptions: DatacenterOption[] = [
  {
    value: 'DC-01',
    label: 'DC-01'
  },
  {
    value: 'DC-02',
    label: 'DC-02'
  },
  {
    value: 'DC-03',
    label: 'DC-03'
  },
  {
    value: 'DC-04',
    label: 'DC-04'
  }
]

export const clevertapRegionOption: DatacenterOption[] = [
  {
    value: 'EU',
    label: 'Europe'
  },
  {
    value: 'IN',
    label: 'India'
  },
  {
    value: 'US',
    label: 'United States'
  },
  {
    value: 'Singapore',
    label: 'Singapore'
  }
]

export const Identity: IdentityOptionType[] = [
  {
    value: 'email',
    label: 'Email'
  },
  {
    value: 'phone',
    label: 'Phone'
  }
]
export const paymentsConfig: PaymentsConfig[] = [
  {
    type: 'gateways',
    icon: Link,
    label: 'Connect payment gateways'
  },
  {
    type: 'methods',
    icon: Zap,
    label: 'Configure payment methods'
  }
]

export const membersRolesChildren: any[] = [
  {
    type: 'new-role',
    label: 'New role'
  },
  {
    type: 'edit-role',
    label: 'Edit role'
  },
  {
    type: 'recipient',
    label: 'Add recipient'
  }
]

export enum PAYMENT_GATEWAY {
  RP = 'RP',
  CF = 'CF',
  PAYU = 'PAYU',
  PAYTM = 'PAYTM',
  PHONEPE = 'PHONEPE',
  CCAVENUE = 'CCAVENUE',
  SNPM = 'SNPM',
  BHARATX = 'BHARATX',
  EASEBUZZ = 'EASEBUZZ',
  VELOCITY = 'VELOCITY',
  SIMPL = 'SIMPL'
}

export const paymentGatewaysConfig: IPaymentGateways[] = [
  {
    type: 'RP',
    imgPath: '/images/payments/razorpay.svg',
    label: 'Razorpay',
    helpUrl: 'https://intercom.help/shopflo-a9de00772be8/en/articles/10126225-setup-razorpay-pg-on-shopflo',
    inputConfigs: [
      {
        label: 'API key',
        type: 'text',
        valueType: 'pgKey',
        payloadKey: 'key'
      },
      {
        label: 'API secret',
        type: 'text',
        valueType: 'pgSecret',
        payloadKey: 'secret'
      }
    ]
  },
  {
    type: 'CF',
    imgPath: '/images/payments/cashfree.svg',
    label: 'Cashfree',
    helpUrl: 'https://intercom.help/shopflo-a9de00772be8/en/articles/10126189-setup-cashfree-pg-on-shopflo',
    inputConfigs: [
      {
        label: 'API key',
        type: 'text',
        valueType: 'pgKey',
        payloadKey: 'key'
      },
      {
        label: 'API secret',
        type: 'text',
        valueType: 'pgSecret',
        payloadKey: 'secret'
      }
    ]
  },
  {
    //check the inputConfig usage here, remove it if not required:
    type: 'PLURAL',
    imgPath: '/images/payments/pinePG.jpg',
    label: 'Pine labs',
    helpUrl: 'https://intercom.help/shopflo-a9de00772be8/en/articles/10126189-setup-pine-pg-on-shopflo',
    inputConfigs: [
      {
        label: 'MID',
        type: 'text',
        valueType: 'merchant_id',
        payloadKey: 'pg_merchant_id'
      },
      {
        label: 'Client ID',
        type: 'text',
        valueType: 'pgKey',
        payloadKey: 'key'
      },
      {
        label: 'Client Secret',
        type: 'text',
        valueType: 'pgSecret',
        payloadKey: 'secret'
      }
    ]
  },
  {
    type: 'PAYU',
    imgPath: '/images/payments/payu.svg',
    label: 'PayU',
    helpUrl: 'https://intercom.help/shopflo-a9de00772be8/en/articles/10126177-setup-payu-pg-on-shopflo',
    inputConfigs: [
      {
        label: 'API key',
        type: 'text',
        valueType: 'pgKey',
        payloadKey: 'key'
      },
      {
        label: 'API secret',
        type: 'text',
        valueType: 'pgSecret',
        payloadKey: 'secret'
      }
    ]
  },
  {
    type: 'PAYTM',
    imgPath: '/images/payments/paytm.svg',
    label: 'Paytm',
    helpUrl: 'https://intercom.help/shopflo-a9de00772be8/en/articles/10126167-setup-paytm-pg-on-shopflo',
    inputConfigs: [
      {
        label: 'API key',
        type: 'text',
        valueType: 'pgKey',
        payloadKey: 'key'
      },
      {
        label: 'API secret',
        type: 'text',
        valueType: 'pgSecret',
        payloadKey: 'secret'
      }
    ]
  },
  {
    type: 'PHONEPE',
    imgPath: '/images/payments/phonepe.svg',
    label: 'PhonePe',
    helpUrl: 'https://intercom.help/shopflo-a9de00772be8/en/articles/10126159-setup-phonepe-pg-on-shopflo',
    inputConfigs: [
      {
        label: 'MID',
        type: 'text',
        valueType: 'pgMerchantId',
        payloadKey: 'pg_merchant_id'
      },
      {
        label: 'Salt key',
        type: 'text',
        valueType: 'pgSecret',
        payloadKey: 'secret'
      },
      {
        label: 'Salt index',
        type: 'text',
        valueType: 'saltIndex',
        payloadKey: 'salt_index'
      }
    ]
  },
  {
    type: 'PHONEPE_V2',
    imgPath: '/images/payments/phonepe.svg',
    label: 'PhonePe V2',
    helpUrl: 'https://intercom.help/shopflo-a9de00772be8/en/articles/10126159-setup-phonepe-pg-on-shopflo',
    inputConfigs: [
      {
        label: 'MID',
        type: 'text',
        valueType: 'pgMerchantId',
        payloadKey: 'pg_merchant_id'
      },
      {
        label: 'Referer domain (Optional)',
        type: 'text',
        valueType: 'refererDomain',
        payloadKey: 'referer_domain',
        isOptional: true
      }
    ]
  },
  {
    type: 'CCAVENUE',
    imgPath: '/images/payments/ccavenue.svg',
    label: 'CC Avenue',
    helpUrl: 'https://intercom.help/shopflo-a9de00772be8/en/articles/10126232-setup-ccavenue-pg-on-shopflo',
    inputConfigs: [
      {
        label: 'API key',
        type: 'text',
        valueType: 'pgKey',
        payloadKey: 'key'
      },
      {
        label: 'API secret',
        type: 'text',
        valueType: 'pgSecret',
        payloadKey: 'secret'
      },
      {
        label: 'PG merchant Id',
        type: 'text',
        valueType: 'pgMerchantId',
        payloadKey: 'pg_merchant_id'
      }
    ]
  },
  {
    type: 'SNPM',
    imgPath: '/images/payments/snapmint.svg',
    label: 'Snapmint',
    inputConfigs: [
      {
        label: 'API key',
        type: 'text',
        valueType: 'pgKey',
        payloadKey: 'key'
      },
      {
        label: 'API secret',
        type: 'text',
        valueType: 'pgSecret',
        payloadKey: 'secret'
      }
    ]
  },
  {
    type: 'BHARATX',
    imgPath: '/images/payments/bharatx.svg',
    label: 'BharatX',
    helpUrl: 'https://intercom.help/shopflo-a9de00772be8/en/articles/10411374-how-to-enable-bharatx-on-shopflo',
    inputConfigs: [
      {
        label: 'API key',
        type: 'text',
        valueType: 'pgKey',
        payloadKey: 'key'
      },
      {
        label: 'API secret',
        type: 'text',
        valueType: 'pgSecret',
        payloadKey: 'secret'
      }
    ]
  },
  {
    type: 'VELOCITY',
    imgPath: 'https://d2s4qtdvyggozf.cloudfront.net/velocity.png',
    label: 'Velocity',
    inputConfigs: [
      {
        label: 'API key',
        type: 'text',
        valueType: 'pgKey',
        payloadKey: 'key'
      },
      {
        label: 'API secret',
        type: 'text',
        valueType: 'pgSecret',
        payloadKey: 'secret'
      },
      {
        label: 'Merchant ID',
        type: 'text',
        valueType: 'pgMerchantId',
        payloadKey: 'merchant_id'
      }
    ]
  },
  {
    type: 'EASEBUZZ',
    imgPath: '/images/payments/easebuzz-logo.svg',
    label: 'Easebuzz',
    helpUrl: 'https://intercom.help/shopflo-a9de00772be8/en/articles/10126146-setup-easebuzz-pg-on-shopflo',
    inputConfigs: [
      {
        label: 'API key',
        type: 'text',
        valueType: 'pgKey',
        payloadKey: 'key'
      },
      {
        label: 'API secret',
        type: 'text',
        valueType: 'pgSecret',
        payloadKey: 'secret'
      }
    ]
  }
]

// Object mapping payment gateway types to their configurations
export const paymentGatewaysConfigMap = paymentGatewaysConfig.reduce((acc, gateway) => {
  acc[gateway.type] = gateway
  return acc
}, {} as Record<string, IPaymentGateways>)

export const defaultGatewayStateConfig: GatewayStateConfigType[] = [
  {
    pg: 'RP',
    pgMerchantId: '',
    pgKey: '',
    pgSecret: ''
  },
  {
    pg: 'CF',
    pgMerchantId: '',
    pgKey: '',
    pgSecret: ''
  },
  {
    pg: 'PAYU',
    pgMerchantId: '',
    pgKey: '',
    pgSecret: ''
  },
  {
    pg: 'PAYTM',
    pgMerchantId: '',
    pgKey: '',
    pgSecret: ''
  },
  {
    pg: 'PHONEPE',
    pgMerchantId: '',
    pgKey: '',
    pgSecret: '',
    saltIndex: ''
  },
  {
    pg: 'CCAVENUE',
    pgMerchantId: '',
    pgKey: '',
    pgSecret: ''
  },
  {
    pg: 'SNPM',
    pgMerchantId: '',
    pgKey: '',
    pgSecret: ''
  },
  {
    pg: 'VELOCITY',
    pgMerchantId: '',
    pgKey: '',
    pgSecret: ''
  },
  {
    pg: 'BHARATX',
    pgMerchantId: '',
    pgKey: '',
    pgSecret: ''
  },
  {
    pg: 'SIMPL',
    pgSecret: '',
    pgKey: '',
    pgMerchantId: ''
  }
]

export const settingsConfig: SettingsConfig = [
  {
    type: 'shop-details',
    icon: ShoppingBag,
    is_mandatory: true,
    label: 'Connect your shop',
    pageHeader: 'Connect your shop',
    tagText: 'Connect your shop',
    progressConfig: {
      title: 'Getting started',
      description: '',
      oneLiner: '',
      nextStep: 'payments'
    }
  },
  {
    type: 'payments',
    icon: CreditCard,
    is_mandatory: true,
    label: 'Payment settings',
    pageHeader: 'Payments',
    tagText: 'Connect atleast 1 payment gateway',
    children: paymentGatewaysConfig,
    progressConfig: {
      title: 'Getting started',
      description: 'Configure your preferred payment gateways to start accepting payments from your customers.',
      oneLiner: 'Connect a payment gateway',
      nextStep: 'payments'
    }
  },
  {
    type: 'channels',
    icon: Terminal,
    is_mandatory: true,
    label: 'Channels',
    pageHeader: 'Channels',
    tagText: 'Please add organisation details to create channels',
    children: [
      {
        type: 'singleton',
        imgPath: '',
        label: 'View channel'
      }
    ],
    progressConfig: {
      title: 'Getting started',
      description: '',
      oneLiner: 'Add channels'
    }
  },
  {
    type: 'integrations',
    icon: Radio,
    is_mandatory: false,
    label: 'Integrations',
    pageHeader: 'Integrations',
    children: integrationsConfig,
    progressConfig: {
      title: 'Getting started',
      description: 'Ensure your events flow into your analytics.',
      oneLiner: 'Set up integrations',
      nextStep: 'themes'
    }
  },
  {
    type: 'members',
    icon: Users,
    is_mandatory: false,
    label: 'Members and roles',
    pageHeader: 'Members and roles',
    children: membersRolesChildren
  },
  {
    type: 'billing-usage',
    icon: Umbrella,
    is_mandatory: true,
    label: 'Billing and usage',
    tagText: 'Add your organisation details for invoicing',
    pageHeader: 'Billing and usage'
  },
  {
    type: 'profile',
    icon: User,
    is_mandatory: true,
    label: 'My profile',
    pageHeader: 'My profile'
  },
  {
    type: 'activity-logs',
    icon: User,
    is_mandatory: true,
    label: 'Activity Logs',
    pageHeader: 'Activity Log'
  },
  {
    type: 'organisational-details',
    icon: Briefcase,
    is_mandatory: true,
    label: 'Organisational details',
    pageHeader: 'Organisational details'
  }
]

export const settingTitleList = ['Setup', 'Shop settings', 'Invoicing', 'Account']
export const settingListConfig = [
  [
    {
      type: 'organisational-details',
      icon: Briefcase,
      is_mandatory: true,
      label: 'Organisational details',
      pageHeader: 'Organisational details'
    },
    {
      type: 'channels',
      icon: Terminal,
      is_mandatory: true,
      label: 'Channels',
      pageHeader: 'Channels',
      children: [
        {
          type: 'singleton',
          imgPath: '',
          label: 'View channel'
        }
      ],
      progressConfig: {
        title: 'Getting started',
        description: '',
        oneLiner: 'Add channels'
      }
    }
  ],
  [
    {
      type: 'shop-details',
      icon: ShoppingBag,
      is_mandatory: true,
      label: 'Connect your shop',
      pageHeader: 'Connect your shop',
      tagText: 'Connect your shop',
      progressConfig: {
        title: 'Getting started',
        description: '',
        oneLiner: '',
        nextStep: 'payments'
      }
    },
    {
      type: 'payments',
      icon: CreditCard,
      is_mandatory: true,
      label: 'Payment settings',
      pageHeader: 'Payments',
      tagText: 'Connect atleast 1 payment gateway',
      children: paymentGatewaysConfig,
      progressConfig: {
        title: 'Getting started',
        description: 'Configure your preferred payment gateways to start accepting payments from your customers.',
        oneLiner: 'Connect a payment gateway',
        nextStep: 'payments'
      }
    },
    ,
    {
      type: 'integrations',
      icon: Radio,
      is_mandatory: false,
      label: 'Integrations',
      pageHeader: 'Integrations',
      children: integrationsConfig,
      progressConfig: {
        title: 'Getting started',
        description: 'Ensure your events flow into your analytics.',
        oneLiner: 'Set up integrations',
        nextStep: 'themes'
      }
    }
  ],
  [
    {
      type: 'billing-usage',
      icon: Umbrella,
      is_mandatory: true,
      label: 'Billing and usage',
      pageHeader: 'Billing and usage'
    }
  ],
  [
    {
      type: 'activity-logs',
      icon: Users,
      is_mandatory: true,
      label: 'Activity Logs',
      pageHeader: 'Activity Log'
    },
    {
      type: 'members',
      icon: Users,
      is_mandatory: false,
      label: 'Members and roles',
      pageHeader: 'Members and roles',
      children: membersRolesChildren
    },
    ,
    {
      type: 'profile',
      icon: User,
      is_mandatory: true,
      label: 'My profile',
      pageHeader: 'My profile'
    }
  ]
]

export enum PAYMENT_METHOD {
  UPI = 'UPI',
  CARD = 'CARD',
  WALLET = 'WALLET',
  NETBANKING = 'NETBANKING',
  EMI = 'EMI',
  PAY_LATER = 'PAY_LATER',
  COD = 'COD',
  SNPM = 'SNPM',
  VELOCITY = 'VELOCITY',
  BHARATX = 'BHARATX',
  SPLIT_COD = 'SPLIT_COD',
  SIMPL = 'SIMPL',
  SIMPL_PL = 'SIMPL_PL',
  UPI_INTENT = 'UPI_INTENT'
}

export const paymentMethods: IPaymentGateways[] = [
  {
    type: 'UPI',
    imgPath: '/images/payments/upi.svg',
    label: 'UPI',
    defaultTitle: 'Pay using UPI'
  },
  {
    type: 'CARD',
    imgPath: '/images/payments/cards.svg',
    label: 'Cards',
    defaultTitle: 'Cards'
  },
  {
    type: 'WALLET',
    imgPath: '/images/payments/wallets.svg',
    label: 'Wallets',
    defaultTitle: 'Wallets'
  },
  {
    type: 'NETBANKING',
    imgPath: '/images/payments/netbanking.svg',
    label: 'Netbanking',
    defaultTitle: 'Netbanking'
  },
  {
    type: 'EMI',
    imgPath: '/images/payments/emi.svg',
    label: 'EMI',
    defaultTitle: 'EMIs'
  },
  {
    type: 'PAY_LATER',
    imgPath: '/images/payments/paylater.svg',
    label: 'Paylater',
    defaultTitle: 'Pay later'
  },
  {
    type: 'COD',
    imgPath: '/images/payments/cod.svg',
    label: 'Cash on delivery',
    defaultTitle: 'Cash on delivery'
  },
  {
    type: 'SPLIT_COD',
    imgPath: '/images/payments/cod.svg',
    label: 'Split COD',
    defaultTitle: 'Partial COD'
  },
  {
    type: 'BHARATX',
    imgPath: '/images/payments/netbanking.svg',
    label: 'BharatX',
    defaultTitle: 'BharatX'
  },
  {
    type: 'SNPM',
    imgPath: '/images/payments/snpm.svg',
    label: 'Snapmint',
    defaultTitle: 'Snapmint'
  },
  {
    type: 'VELOCITY',
    imgPath: 'https://d2s4qtdvyggozf.cloudfront.net/velocity.png',
    label: 'Velocity',
    defaultTitle: 'Velocity Pay'
  },
  {
    type: 'UPI_INTENT',
    imgPath: '/images/payments/upi.svg',
    label: 'UPI Intent',
    defaultTitle: 'UPI Intent'
  }
]

export const initialMembersRolesTabList = [
  {
    isActive: true,
    label: 'Members',
    name: 'members',
    childComponent: 'MembersLookup'
  },
  {
    isActive: false,
    label: 'Roles',
    name: 'roles',
    childComponent: 'RolesLookup'
  }
]

export const accountTypeOptions = [
  { value: 'members', label: 'Members list' },
  { value: 'invitations', label: 'Invitations' }
]

export const initialFormErrorState: ChannelCreationFormErrorState = {
  name: {
    status: false,
    errorCode: ''
  }
}

export const defaultUserProfile: UserProfileState = {
  firstName: '',
  lastName: '',
  phoneNumber: '91',
  role: '',
  email: ''
}
export const defaultUserProfileErrorState: UserProfileErrorState = {
  firstName: false,
  phoneNumber: false,
  role: false,
  email: false
}

export const HIDDEN_PAYMENT_MODE_DISCOUNT_CONCESSION = [
  'REWARDS_WALLET',
  'LOYALTY',
  'GYFTR',
  'FREE',
  'OFFLINE_PAYMENT',
  'COD',
  'GIFTCARD',
  'SIMPL',
  'SIMPL_PL'
]

export const defaultRecipient = {
  firstName: '',
  lastName: '',
  phoneNumber: '91',
  role: 'Founder',
  email: ''
}

export const OauthGateways = ['RP', 'CF']
